import React, { useState } from "react";
import "../Styles/Gallery.scss";
// import img1 from "../Image/bg.webp";
// import img2 from "../Image/about-bg.webp";
// import img3 from "../Image/restaurant.webp";
// import img4 from "../Image/dblroom.jpg";
// import img5 from "../Image/tripleroom.webp";
// import img6 from "../Image/quadroom.webp";
// import img7 from "../Image/7.webp";
// import img8 from "../Image/8.webp";
// import img9 from "../Image/9.webp";
// import img10 from "../Image/10.webp";
// import img11 from "../Image/11.webp";
// import img12 from "../Image/12.webp";
import img13 from "../Image/img13.JPG";
import img14 from "../Image/img14.JPG";
import img17 from "../Image/img17.JPG";
import img15 from "../Image/img15.JPG";
import img30 from "../Image/img30.JPG";
import img29 from "../Image/img29.JPG";
import img28 from "../Image/img28.JPG";
import img25 from "../Image/img25.JPG";
import img26 from "../Image/img26.JPG";
import img27 from "../Image/img27.JPG";
import img24 from "../Image/img24.JPG";
import img18 from "../Image/img18.JPG";
import img22 from "../Image/img22.JPG";
import img21 from "../Image/img21.JPG";
import img20 from "../Image/img20.JPG";
import img19 from "../Image/img19.JPG";
import img42 from "../Image/img42.JPG";
import img40 from "../Image/img40.JPG";
import img41 from "../Image/img41.JPG";
import img33 from "../Image/img33.JPG";
import img37 from "../Image/img37.JPG";
import img39 from "../Image/img39.JPG";
import img32 from "../Image/img32.JPG";
import img35 from "../Image/img35.JPG";
import img36 from "../Image/img36.JPG";
import img38 from "../Image/img38.JPG";
import img31 from "../Image/img31.JPG";
import img34 from "../Image/img34.JPG";
import img23 from "../Image/img23.JPG";
import img16 from "../Image/img16.JPG";

const images = [
  img13,
  img14,
  img17,
  img15,
  img30,
  img29,
  img28,
  img25,
  img26,
  img27,
  img24,
  img18,
  img22,
  img21,
  img20,
  img19,
  img42,
  img40,
  img41,
  img33,
  img37,
  img39,
  img32,
  img35,
  img36,
  img38,
  img31,
  img34,
  img23,
  img16,
];

const Gallery = () => {
  const [visibleCount, setVisibleCount] = useState(6);
  const [activeImage, setActiveImage] = useState(null);

  const toggleImages = () => {
    setVisibleCount(visibleCount === 6 ? images.length : 6);
  };

  return (
    <section className="gallery-page">
      <div className="gallery-container">
        <h2>OUR GALLERY</h2>
        <p>Moments of elegance, comfort, and timeless hospitality.</p>

        <div className="gallery-grid">
          {images.slice(0, visibleCount).map((img, index) => (
            <div
              className="gallery-item"
              key={index}
              onClick={() => setActiveImage(img)}
            >
              <img src={img} alt="Kurti Hotel Gallery" />
            </div>
          ))}
        </div>

        <button className="toggle-btn" onClick={toggleImages}>
          {visibleCount === 6 ? "Show More" : "Show Less"}
        </button>
      </div>

      {activeImage && (
        <div className="gallery-modal" onClick={() => setActiveImage(null)}>
          <span className="close">&times;</span>
          <img src={activeImage} alt="Full View" />
        </div>
      )}
    </section>
  );
};

export default Gallery;
